import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import Select from "PFComponents/select/select";
import InputFieldSet from "PFComponents/text/input_field_set";
import Toggle from "PFComponents/toggle/toggle";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./new_user_page.less";

const NewUserPage = ({ permissionsGroups }) => {
  const { t } = useTranslation("admin", { keyPrefix: "users.new" });
  const history = useHistory();
  const options = useMemo(
    () =>
      permissionsGroups?.map((option) => ({
        id: option.id,
        displayElement: option.display_as,
        item: option
      })),
    [permissionsGroups]
  );
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [permissionsGroup, setPermissionsGroup] = useState(permissionsGroups?.find((item) => item.default));
  const [sendWelcomeEmail, setSendWelcomeEmail] = useState(false);
  const [errors, setErrors] = useState(null);

  const saveUser = () => {
    const data = {
      email: email,
      first_name: firstName,
      last_name: lastName,
      options: {
        notify: sendWelcomeEmail
      }
    };

    if (permissionsGroup) {
      data.permissions_group = { id: permissionsGroup.id };
    }

    $.ajax({
      method: "POST",
      url: ApiRoute("/api/admin/users"),
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data)
    })
      .then(() => history.push("/admin/users"))
      .catch((err) => {
        setErrors(err?.responseJSON?.errors);
      });
  };

  return (
    <div>
      <h1 className={css.header}>{t("header")}</h1>
      <PageBox style={{ padding: 20, maxWidth: 900 }}>
        <InputFieldSet
          type="text"
          label={t("firstName")}
          value={firstName}
          style={{ width: "100%" }}
          controlledValue
          handleChange={setFirstName}
          error={errors?.first_name}
        />
        <InputFieldSet
          type="text"
          label={t("lastName")}
          value={lastName}
          style={{ width: "100%", marginTop: 30 }}
          controlledValue
          handleChange={setLastName}
          error={errors?.last_name}
        />
        <InputFieldSet
          type="email"
          label={t("email")}
          value={email}
          style={{ width: "100%", marginTop: 30 }}
          controlledValue
          handleChange={setEmail}
          error={errors?.email}
        />
        {permissionsGroups && (
          <Select
            label={t("permissionsGroup")}
            options={options}
            handleChange={(value) => setPermissionsGroup(value)}
            style={{ marginTop: 30 }}
            error={errors?.permission_group}
            selectedIndex={options?.findIndex(({ id }) => id === permissionsGroup?.id)}
            controlledValue
            value={permissionsGroup?.display_as}
          />
        )}
        <Toggle
          label={t("welcomeEmail")}
          tip={t("welcomeEmailTip")}
          checked={sendWelcomeEmail}
          onChange={setSendWelcomeEmail}
          inline
        />
        <div className={css.buttons}>
          <ButtonLink kind="tertiary" href="/admin/users">
            {t("translation:cancel")}
          </ButtonLink>
          <Button text={t("translation:save")} kind="primary" onClick={saveUser} />
        </div>
      </PageBox>
    </div>
  );
};

NewUserPage.propTypes = {
  permissionsGroups: PropTypes.array
};

export default NewUserPage;
